import { render, staticRenderFns } from "./authPage.vue?vue&type=template&id=2af63ca1&scoped=true"
import script from "./authPage.vue?vue&type=script&lang=js"
export * from "./authPage.vue?vue&type=script&lang=js"
import style0 from "./authPage.vue?vue&type=style&index=0&id=2af63ca1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af63ca1",
  null
  
)

export default component.exports